import { ConsumablesMasterThemeSizeConfig } from './types';

const medium: ConsumablesMasterThemeSizeConfig = {
  consumablesMaster: {},
};

export default medium;
